import { BsMusicNoteBeamed } from 'react-icons/bs';
import {useRef, useState, useEffect} from "react";
import "./_trackplayer.scss";
import Controls from '../../HomePage/MusicSection/Controls';
import Waveform from '../../HomePage/MusicSection/WaveForm';

const TrackPlayer = ({ currentTrack, logo, activeTrackId, setActiveTrackId, onTrackEnd, isAudiobook }) => {
  const [isTrackPlaying, setIsTrackPlaying] = useState(false);
  const [isVisible, setIsVisible] = useState(false);
  const wavesurferRef = useRef();
  const cardRef = useRef();

  useEffect(() => {
    if (!cardRef.current) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.disconnect();
        }
      },
      { threshold: 0.1 }
    );

    observer.observe(cardRef.current);
    return () => observer.disconnect();
  }, []);

  useEffect(() => {
    if (activeTrackId === currentTrack?.title + currentTrack?.id) {
      wavesurferRef.current?.play();
      setIsTrackPlaying(true);
    } else {
      wavesurferRef.current?.pause();
      setIsTrackPlaying(false);
    }
  }, [activeTrackId, currentTrack]);

  return (
    <div ref={cardRef}>
      <div className={`audio-info ${isAudiobook ? 'audiobooks' : ''}`}>
        <div className="audio-controls">
          <div className="audio-image-preview">
            {currentTrack?.cover ? (
              <img src={currentTrack.cover} alt="audio avatar" />
            ) : (
              <div className="icon-wrapper">
                <span className="audio-icon"><BsMusicNoteBeamed /></span>
              </div>
            )}
            <Controls
              wavesurferRef={wavesurferRef}
              isTrackPlaying={isTrackPlaying}
              setIsTrackPlaying={setIsTrackPlaying}
              trackName={currentTrack?.title}
              trackId={currentTrack?.id}
              setActiveTrackId={setActiveTrackId}
              onTrackEnd={onTrackEnd}
            />
          </div>
          <div style={{ height: "100%", position: "relative", width: "calc(100% - 200px)" }}>
            <div className="text">
              <p className="title">{currentTrack?.title}</p>
              {currentTrack?.author && <p className="author">{currentTrack?.author}</p>}
            </div>
            <Waveform audioUrl={currentTrack?.audio} wavesurferRef={wavesurferRef} isVisible={isVisible}/>
          </div>
        </div>
        {logo && currentTrack?.link && (
          <a className="audiobook_logo" target="_blank" rel="noopener noreferrer" href={currentTrack?.link}>
            <img src={logo} alt="logo" className="audiobook_logo" />
          </a>
        )}
      </div>
    </div>
  );
}

export default TrackPlayer;